import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

export const BottomCTA = () => {
  return (
    <section className="py-16 md:py-20 bg-[#132723]" data-testid="bottom-cta">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <h2 className="text-2xl md:text-3xl font-serif text-white mb-4">
          Curious What Your Home Could Sell For?
        </h2>
        <p className="text-white/70 mb-8 max-w-2xl mx-auto">
          Get an instant home value estimate plus local expert insights. No obligation, no spam.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            asChild
            className="bg-white text-[#132723] hover:bg-[#f0efeb] px-8 py-6 text-lg font-medium"
            data-testid="bottom-cta-button"
          >
            <a 
              href="https://homevalue.graysharborrealtor.com/" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Get Your Free Home Value
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
          </Button>
          
          <a 
            href="tel:+13605810167"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 border-2 border-white text-white hover:bg-white hover:text-[#132723] transition-colors font-medium"
            data-testid="bottom-phone-button"
          >
            <Phone className="w-4 h-4" />
            Call Chris: (360) 581-0167
          </a>
        </div>
      </div>
    </section>
  );
};

export default BottomCTA;
